<template>
  <button
    class="relative w-40 h-24 rounded-full transition-all"
    :class="{
      'bg-mintPrimary': selected,
      'bg-light': !selected
    }"
    @click="toggle"
  >
    <div
      class="w-20 h-20 absolute bg-lightest top-2 rounded-full transition-all"
      :class="{
        'left-[18px]': selected,
        'left-2': !selected
      }"
    />
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{
  selected: boolean,
}>();

const emit = defineEmits<{
  (e: 'set', payload: boolean): void;
}>();

const toggle = () => {
  emit('set', !props.selected);
};

</script>

<style scoped lang="postcss">
</style>
